import React from 'react';
import { Sidebar } from '../../components/Sidebar';
import { Header } from '../../components/Header';
import { SparklesIcon, ExpandIcon, PlayCircleIcon, ImageIcon, VideoIcon, CheckIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function DealerCreativeDashboard() {
  const navigate = useNavigate();
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-1249">
      <Sidebar data-id="element-1250" />
      <main className="flex-1" data-id="element-1251">
        <Header data-id="element-1252" />
        <div className="px-6 py-8" data-id="element-1253">
          <div className="max-w-6xl mx-auto" data-id="element-1254">
            <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-1255">
              Creative Customizer
            </h1>
            <p className="text-gray-600 mb-8" data-id="element-1256">
              Create professional, brand-compliant creatives in minutes
            </p>

            <div className="grid grid-cols-3 gap-6" data-id="element-1257">
              {/* AI Creative Generator */}
              <div className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-1258">
                <div className="p-6" data-id="element-1259">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6" data-id="element-1260">
                    <SparklesIcon className="text-blue-600" size={32} data-id="element-1261" />
                  </div>
                  <h2 className="text-xl font-semibold text-gray-800 mb-3" data-id="element-1262">
                    AI Creative Generator
                  </h2>
                  <p className="text-gray-600 mb-6 text-sm" data-id="element-1263">
                    Create brand-compliant creatives from scratch with
                    AI-powered image generation
                  </p>

                  <div className="space-y-3 mb-6" data-id="element-1264">
                    <div className="flex items-start text-sm text-gray-700" data-id="element-1265">
                      <CheckIcon size={16} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1266" />
                      <span data-id="element-1267">Generate static images</span>
                    </div>
                    <div className="flex items-start text-sm text-gray-700" data-id="element-1268">
                      <CheckIcon size={16} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1269" />
                      <span data-id="element-1270">Multiple format outputs (1:1, 9:16, 16:9)</span>
                    </div>
                    <div className="flex items-start text-sm text-gray-700" data-id="element-1271">
                      <CheckIcon size={16} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1272" />
                      <span data-id="element-1273">AI-powered backgrounds and compositions</span>
                    </div>
                  </div>

                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-6" data-id="element-1274">
                    <p className="text-xs text-blue-800" data-id="element-1275">
                      <strong data-id="element-1276">Output:</strong> Image and/or Video
                    </p>
                  </div>

                  <button onClick={() => navigate('/dealer/ai-generator/step-1')} className="w-full bg-blue-500 text-white px-6 py-3 rounded-md font-medium hover:bg-blue-600 transition-colors" data-id="element-1277">
                    Start Creating
                  </button>
                </div>
              </div>

              {/* Creative Resizer */}
              <div className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-1278">
                <div className="p-6" data-id="element-1279">
                  <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-6" data-id="element-1280">
                    <ExpandIcon className="text-purple-600" size={32} data-id="element-1281" />
                  </div>
                  <h2 className="text-xl font-semibold text-gray-800 mb-3" data-id="element-1282">
                    Creative Resizer
                  </h2>
                  <p className="text-gray-600 mb-6 text-sm" data-id="element-1283">
                    Adapt existing creatives to different platform formats with
                    AI-powered resizing
                  </p>

                  <div className="space-y-3 mb-6" data-id="element-1284">
                    <div className="flex items-start text-sm text-gray-700" data-id="element-1285">
                      <CheckIcon size={16} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1286" />
                      <span data-id="element-1287">Smart crop with focal point preservation</span>
                    </div>
                    <div className="flex items-start text-sm text-gray-700" data-id="element-1288">
                      <CheckIcon size={16} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1289" />
                      <span data-id="element-1290">Intelligent expansion to fill space</span>
                    </div>
                    <div className="flex items-start text-sm text-gray-700" data-id="element-1291">
                      <CheckIcon size={16} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1292" />
                      <span data-id="element-1293">Multiple format outputs instantly</span>
                    </div>
                  </div>

                  <div className="bg-purple-50 border border-purple-200 rounded-lg p-3 mb-6" data-id="element-1294">
                    <p className="text-xs text-purple-800" data-id="element-1295">
                      <strong data-id="element-1296">Output:</strong> Multiple format versions
                    </p>
                  </div>

                  <button onClick={() => navigate('/dealer/resizer/step-1')} className="w-full bg-purple-500 text-white px-6 py-3 rounded-md font-medium hover:bg-purple-600 transition-colors" data-id="element-1297">
                    Resize Creative
                  </button>
                </div>
              </div>

              {/* Image to Video Generator */}
              <div className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-1298">
                <div className="p-6" data-id="element-1299">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6" data-id="element-1300">
                    <PlayCircleIcon className="text-green-600" size={32} data-id="element-1301" />
                  </div>
                  <h2 className="text-xl font-semibold text-gray-800 mb-3" data-id="element-1302">
                    Image to Video
                  </h2>
                  <p className="text-gray-600 mb-6 text-sm" data-id="element-1303">
                    Transform static product images into professional video ads
                    with AI-powered motion
                  </p>

                  <div className="space-y-3 mb-6" data-id="element-1304">
                    <div className="flex items-start text-sm text-gray-700" data-id="element-1305">
                      <CheckIcon size={16} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1306" />
                      <span data-id="element-1307">Convert images to 4-8 second videos</span>
                    </div>
                    <div className="flex items-start text-sm text-gray-700" data-id="element-1308">
                      <CheckIcon size={16} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1309" />
                      <span data-id="element-1310">AI-powered motion and camera effects</span>
                    </div>
                    <div className="flex items-start text-sm text-gray-700" data-id="element-1311">
                      <CheckIcon size={16} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1312" />
                      <span data-id="element-1313">Maintains exact product design</span>
                    </div>
                  </div>

                  <div className="bg-green-50 border border-green-200 rounded-lg p-3 mb-6" data-id="element-1314">
                    <p className="text-xs text-green-800" data-id="element-1315">
                      <strong data-id="element-1316">Output:</strong> Professional video ad
                    </p>
                  </div>

                  <button onClick={() => navigate('/dealer/video-generator/upload')} className="w-full bg-green-500 text-white px-6 py-3 rounded-md font-medium hover:bg-green-600 transition-colors" data-id="element-1317">
                    Generate Video
                  </button>
                </div>
              </div>
            </div>

            {/* Benefits Section */}
            <div className="mt-12 bg-white rounded-lg border border-gray-200 p-8" data-id="element-1318">
              <h3 className="text-lg font-semibold text-gray-800 mb-6 text-center" data-id="element-1319">
                Why Use Creative Customizer?
              </h3>
              <div className="grid grid-cols-3 gap-8" data-id="element-1320">
                <div className="text-center" data-id="element-1321">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-1322">
                    <CheckIcon className="text-blue-600" size={24} data-id="element-1323" />
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-2" data-id="element-1324">
                    Brand Compliant
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-1325">
                    All creatives follow approved brand guidelines automatically
                  </p>
                </div>
                <div className="text-center" data-id="element-1326">
                  <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-1327">
                    <SparklesIcon className="text-purple-600" size={24} data-id="element-1328" />
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-2" data-id="element-1329">
                    Zero Design Skills
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-1330">
                    Pre-set templates and animations make it easy for anyone
                  </p>
                </div>
                <div className="text-center" data-id="element-1331">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-1332">
                    <VideoIcon className="text-green-600" size={24} data-id="element-1333" />
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-2" data-id="element-1334">
                    Professional Quality
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-1335">
                    Ad-like motion and transitions in minutes, not days
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
}